import React from "react";
import RecruitmentListPage from "../../recruitment-shared/pages/RecruitmentListPage";

export default function FacultyRecruitmentsList() {
  return <RecruitmentListPage type="FACULTY" />;
}
